var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"admin-tabs"},_vm._l((_vm.tabs),function(tab){return _c('li',{key:tab.key,class:[
      'admin-tabs__item',
      { 'admin-tabs__item--active': _vm.activeTabKey === tab.key }
    ],on:{"click":function($event){return _vm.$emit('change', tab.key)}}},[_c('span',{staticClass:"admin-tabs__label"},[_vm._v(_vm._s(tab.label))])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }